export const userConstants = {
    GET_ALL_USERS_REQEUST: 'GET_ALL_USERS_REQUEST',
    GET_ALL_USERS_SUCCESS: 'GET_ALL_USERS_SUCCESS',
    GET_ALL_USERS_FAILURE: 'GET_ALL_USERS_FAILURE',

    GET_USER_ACCOUNT_ACCESS_REQEUST: 'GET_USER_ACCOUNT_ACCESS_REQUEST',
    GET_USER_ACCOUNT_ACCESS_SUCCESS: 'GET_USER_ACCOUNT_ACCESS_SUCCESS',
    GET_USER_ACCOUNT_ACCESS_FAILURE: 'GET_USER_ACCOUNT_ACCESS_FAILURE'
}


// WEBPACK FOOTER //
// ./src/constants/user.js